/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import { createDirectStore } from 'direct-vuex';

import { Client } from '@/api';

import dataset from './dataset';
import application from './application';
import upload from './upload';
import { UserLevel } from '@/types';

Vue.use(Vuex);

const {
  store,
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext,
} = createDirectStore({
  state: { client: null as Client | null },
  getters: {
    isAdmin(state): boolean {
      return state.client?.user?.user_level === UserLevel.Admin;
    },
    isSupervisor(state): boolean {
      // @ts-ignore
      return state.client?.user?.user_level <= UserLevel.Supervisor;
    },
    isScorer(state): boolean {
      // @ts-ignore
      return state.client?.user?.user_level <= UserLevel.Scorer;
    },
    isScorerOrAnnotator(state): boolean {
      // @ts-ignore
      return state.client?.user?.user_level <= UserLevel.Annotator;
    },
    isStandardUser(state): boolean {
      // @ts-ignore
      return state.client?.user?.user_level <= UserLevel.User;
    },
    isPasswordResetTime(state): boolean {
      // @ts-ignore
      return state.client?.user?.last_password_at < new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24 * 91).toISOString();
    },
  },
  mutations: {
    setClient(state, client: Client | null) {
      if (state.client !== null) {
        state.client.destroy();
      }

      state.client = client;
    },
  },
  actions: {},
  modules: { dataset, application, upload },
});

// Export the direct-store instead of the classic Vuex store.
export default store;

// The following exports will be used to enable types in the
// implementation of actions and getters.
export {
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext,
};

// The following lines enable types in the injected store '$store'.
export type AppStore = typeof store;
declare module 'vuex' {
  interface Store<S> {
    direct: AppStore;
  }
}
